import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const CircleQuestion = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='CircleQuestion' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,15 L12,14 C12,13 12,12.5 13,12 C14,11.5 15,11 15,9.5 C15,8.5 14,7 12,7 C10,7 9,8.26413718 9,10 M12,16 L12,18' />
  </StyledIcon>
);
